module.exports = __webpack_public_path__ + "static/9-fde0f399fa4b71074e88b511f893c492.woff";